export const tripPlannerQueryKeys = {
  all: ['trip-planner'] as const,
  chatConversations: () => [...tripPlannerQueryKeys.all, 'chat-conversations'] as const,
  chatConversationStats: (filters?: Record<string, unknown>) =>
    [...tripPlannerQueryKeys.chatConversations(), 'stats', filters] as const,
};
